import React, { useState, useEffect } from "react";
import ProjectContainer from "./container/Projects/ProjectContainer";
import Aboutme from "./components/aboutme/Aboutme";
import Skills from "./container/SkillSection/SkillContent";
import Socials from "./components/connect/Socials";
import Resume from "./components/resume/Resume";
import "./app.css";
import Experience from "./components/experience/Experience";

function App() {
  const [lightMode, setLightMode] = useState(false);

  useEffect(() => {
    const savedTheme = localStorage.getItem("theme");
    if (savedTheme === "light") {
      setLightMode(true);
      document.body.classList.add("light");
    }
  }, []);

  useEffect(() => {
    if (lightMode) {
      document.body.classList.add("light");
      localStorage.setItem("theme", "light");
    } else {
      document.body.classList.remove("light");
      localStorage.setItem("theme", "dark");
    }
  }, [lightMode]);

  return (
    <div className="App">
      <button className="theme-toggle" onClick={() => setLightMode(!lightMode)}>
        {lightMode ? "🌙 Dark Mode" : "☀️ Light Mode"}
      </button>

      <Aboutme />
      <Resume />
      <Experience />
      <ProjectContainer />
      <div className="mySocials">
        <Socials />
      </div>
      <Skills />
    </div>
  );
}

export default App;
